import api from './index';
//
let exports = {};

// =====================================入选设备 =====================================
// 获取设备采购需求审核记录
exports.getAdoptedDevicePagedList = function (params, callback) {// 分页获取采购入选设备列表
    api.post('/devcReqr/adopted/device/paged/list/get')
        .data(params)
        .done(callback)
        .go();
};

//通过id获取采购入选设备
exports.getAdoptedDevice = function (params, callback) {// 获取采购入选设备
    api.post('/devcReqr/adopted/device/get')
        .data(params)
        .done(callback)
        .go();
};

// 保存采购入选设备
exports.saveAdoptedDevices = function (params, callback) {// 批量保存采购入选设备[快捷添加]
    api.post('/devcReqr/adopted/devices/save/do')
        .data(params)
        .done(callback)
        .go();
};
// 保存采购入选设备
exports.saveAdoptedDevice = function (params, callback) {// 批量保存采购入选设备[快捷添加]
    api.post('/devcReqr/adopted/device/save/do')
        .data(params)
        .done(callback)
        .go();
};
// 保存采购入选设备
exports.saveContractAdoptedDevice = function (params, callback) {// 批量保存采购入选设备[快捷添加]
    api.post('/devcReqr/adopted/device/save/contract/do')
        .data(params)
        .done(callback)
        .go();
};
// 入选设备关联商品
exports.updateAdoptedDeviceSku = function (params, callback) {// 批量保存采购入选设备[快捷添加]
    api.post('/devcReqr/adopted/device/sku/update/do')
        .data(params)
        .done(callback)
        .go();
};
// 入选设备关联商品
exports.updateAdoptedDeviceAssetDef = function (params, callback) {// 批量保存采购入选设备[快捷添加]
    api.post('/devcReqr/adopted/device/assetDef/update/do')
        .data(params)
        .done(callback)
        .go();
};
//
exports.updateAdoptedDeviceBizAreaOrForm = function (params, callback) {
    api.post('/devcReqr/adopted/device/bizAreaOrForm/update/do')
        .data(params)
        .done(callback)
        .go();
};
exports.updateAdoptedDeviceBizAreaId = function (params, callback) {
    api.post('/devcReqr/adopted/device/bizAreaId/update/do')
        .data(params)
        .done(callback)
        .go();
};
exports.updateAdoptedDeviceBizFromId = function (params, callback) {
    api.post('/devcReqr/adopted/device/bizFromId/update/do')
        .data(params)
        .done(callback)
        .go();
};
// 保存采购入选设备
exports.updateAdoptedDeviceById = function (params, callback) {// 更新采购入选设备
    api.post('/devcReqr/adopted/device/update/do/by/id')
        .data(params)
        .done(callback)
        .go();
};
// 保存采购入选设备
exports.updateAdoptedDevice = function (params, callback) {// 更新采购入选设备
    api.post('/devcReqr/adopted/device/update/do')
        .data(params)
        .done(callback)
        .go();
};

// 删除设备采购需求审核记录
exports.deleteAdoptedDevice = function (params, callback) {
    api.post('/devcReqr/adopted/device/delete/do')
        .data(params)
        .done(callback)
        .go();
};
// 禁用入选商品
exports.doDisabledAdoptedDevice = function (params, callback) {
    api.post('/devcReqr/adopted/device/disabled/do')
        .data(params)
        .done(callback)
        .go();
};
// 根据合同ID禁用采购入选设备
exports.updateAdoptedDeviceDisabledByContractId = function (params, callback) {
    api.post('/devcReqr/adopted/device/disabled/by/contractId/do')
        .data(params)
        .done(callback)
        .go();
};
// 删除设备采购需求审核记录
exports.saveOrderById = function (data, callback) {
    api.post('/devcReqr/order/save/by/id')
        .data(data)
        .done(callback)
        .go();
};
// 批量生成订单
exports.saveOrderBatch = function (data, callback) {
    api.post('/devcReqr/order/save')
        .data(data)
        .done(callback)
        .go();
};
//
exports.getAdoptedDeviceAsmblAccList = function (data, callback) {
    api.post('/devcReqr/adopted/device/asmblAcc/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 根据定义ids查询对应的入围商品
exports.getRequireGoodsAsmblItemListByFilter = function (data, callback) {
    api.post('/devcReqr/goods/asmbl/item/by/filter')
        .data(data)
        .done(callback)
        .go();
};

exports.doInvalidDeviceRequireVoucher = function (data, callback) {
    api.post('/devcReqr/device/require/voucher/invalid')
        .data(data)
        .done(callback)
        .go();
};

// ====================================== 入选服务 ======================================
// 分页获取采购入选服务列表
exports.getAdoptedServcPagedList = function (data, callback) {
    api.post('/devcReqr/adopted/servc/paged/list/get')
        .data(data)
        .done(callback)
        .go();
};

//通过id获取采购入选服务
exports.getAdoptedServcById = function (params, callback) {
    api.get('/devcReqr/adopted/servc/get/by/id')
        .params(params)
        .done(callback)
        .go();
};

// 保存采购入选服务
exports.saveAdoptedServcs = function (data, callback) {
    api.post('/devcReqr/adopted/servcs/save/do')
        .data(data)
        .done(callback)
        .go();
};
// 保存采购入选服务
exports.saveAdoptedServc = function (data, callback) {
    api.post('/devcReqr/adopted/servc/save/do')
        .data(data)
        .done(callback)
        .go();
};

// 修改采购入选服务
exports.updateAdoptedServc = function (data, callback) {
    api.post('/devcReqr/adopted/servc/update/do')
        .data(data)
        .done(callback)
        .go();
};

exports.updateAdoptedServcSsu = function (data, callback) {
    api.post('/devcReqr/adopted/servc/update/ssuId')
        .data(data)
        .done(callback)
        .go();
};

// 删除入选服务
exports.deleteAdoptedServc = function (params, callback) {
    api.post('/devcReqr/adopted/servc/delete/do')
        .params(params)
        .done(callback)
        .go();
};
// =================================== 采购需求单 =====================================
//获取采购需求单列表
exports.getDeviceRequireVoucherList = function (data, callback) {// 获取采购需求列表
    api.post('/devcReqr/device/require/voucher/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.getDeviceRequireVoucherDocsByFilter = function (data, callback) {// 获取采购需求列表
    api.post('/devcReqr/device/require/voucherDoc/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//获取采购需求项列表
exports.getDeviceRequireVoucherInfo = function (data, callback) {// 获取采购需求单
    api.post('/devcReqr/device/require/voucher/info/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//获取采购需求项列表
exports.getContractGoodsItem = function (data, callback) {// 获取采购需求单
    api.post('/devcReqr/contract/goods/item')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//查询汇总商品信息
exports.getRequireGoodsItemDtoByVoucherIds = function (data, callback) {// 获取采购需求单
    api.post('/devcReqr/require/goods/item/dto/list/voucherIds')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//查询汇总商品信息
exports.getRequireGoodsItemDtoByVoucherIdsAndContractIdAndVoucherId = function (data, callback) {// 获取采购需求单
    api.post('/devcReqr/require/goods/item/dto/list/voucherIds/contractId/voucherId')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
//获取采购需求项列表
exports.getDeviceRequireVoucherById = function (params, callback) {// 获取采购需求单
    api.get('/devcReqr/device/require/voucher/get/by/id')
        .params(params)
        .done(callback)
        .fail(callback)
        .go();
};

exports.saveDeviceRequireVoucherForBatch = function (data, callback) {// 多机构-保存采购需求单
    api.post('/devcReqr/device/require/voucher/batch/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.saveDeviceRequireVoucher = function (data, callback) {// 单机构-保存采购需求单
    api.post('/devcReqr/device/require/voucher/save/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.doSubmitDeviceRequireVoucher = function (data, callback) {// 采购需求保存-申请
    api.post('/devcReqr/device/require/voucher/submit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.applyDeviceRequireVoucher = function (data, callback) {// 采购需求申请
    api.post('/devcReqr/device/require/voucher/apply/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.auditDeviceRequireVoucher = function (data, callback) {// 采购需求单审核
    api.post('/devcReqr/device/require/voucher/audit/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};
exports.updateDeviceRequireItems = function (data, callback) {// 批量修改采购需求项
    api.post('/devcReqr/device/require/items/update/do')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

exports.getDeviceRequireAuditRecList = function (data, callback) {// 获取采购需求审核记录列表
    api.post('/devcReqr/device/require/audit/rec/list/get')
        .data(data)
        .done(callback)
        .fail(callback)
        .go();
};

// 给设备采购需求单设置回溯确认岗
exports.setDeviceRequireVoucherBackConfirmPostInfo = function (data, callback) {// 给设备采购需求单设置回溯确认岗
    api.post('/devcReqr/device/require/voucher/backConfirmPostInfo/update/do')
        .data(data)
        .done(callback)
        .go();
};

// 作废采购需求单
exports.updateDeviceRequireVoucherInvalid = function (params, callback) {// 作废采购需求单
    api.post('/devcReqr/device/require/voucher/invalid/do')
        .params(params)
        .done(callback)
        .go();
};

// 删除设备采购需求单
exports.deleteDeviceRequireVoucher = function (params, callback) {// 删除采购需求单
    api.post('/devcReqr/device/require/voucher/delete/do')
        .params(params)
        .done(callback)
        .go();
};

//指定审核人
exports.requestDeviceRequireVoucherAudit = function (postData, callback) {// 请求审核
    api.post('/devcReqr/device/require/voucher/audit/request/do')
        .data(postData)
        .done(callback)
        .go();
};

//指定审核人
exports.getDeviceRequireActRecListByVoucherId = function (params, callback) {// 操作记录
    api.get('/devcReqr/device/require/act/rec/list/get/by/voucherId')
        .params(params)
        .done(callback)
        .go();
};

// 查询采购商品信息数据
exports.getDeviceRequireGoodsByFilter = function (data, callback) {
    api.post('/devcReqr/device/require/goods/list/get')
        .data(data)
        .done(callback)
        .go();
};
// 查询采购服务信息数据
exports.getDeviceRequireServcByFilter = function (data, callback) {
    api.post('/devcReqr/device/require/servc/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getDeviceRequireItemExportUrl = function (data, callback) {
    api.post('/devcReqr/device/require/item/list/export/url/get/by/comId')
        .data(data)
        .done(callback)
        .go();
};
exports.doAdoptedDeviceRelAsmblAcc = function (data, callback) {
    api.post('/devcReqr/adopted/device/rel/asmblAcc/do')
        .data(data)
        .done(callback)
        .go();
};
exports.doCheckAdoptedDeviceRelAssetDef = function (data, callback) {
    api.post('/devcReqr/adopted/device/rel/asmblAcc/check')
        .data(data)
        .done(callback)
        .go();
};
exports.doAdoptedDeviceUnRelAsmblAcc = function (data, callback) {
    api.post('/devcReqr/adopted/device/unrel/asmblAcc/do')
        .data(data)
        .done(callback)
        .go();
};
exports.getRequireGoodsItemByFilter = function (data, callback) {
    api.post('/devcReqr/require/goods/item/get/filter')
        .data(data)
        .done(callback)
        .go();
};
exports.getRequireGoodsItemDeviceIdsByVoucherId = function (data, callback) {
    api.post('/devcReqr/require/goods/item/deviceId/get/voucherId')
        .data(data)
        .done(callback)
        .go();
};
exports.saveRequireGoodsItemList = function (data, callback) {
    api.post('/devcReqr/require/goods/item/list/save')
        .data(data)
        .done(callback)
        .go();
};
// 请购附件信息
exports.getDeviceRequireFileList = function (data, callback) {
    api.post('/devcReqr/device/require/voucher/file/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getAdoptedDeviceCatList = function (data, callback) {
    api.post('/devcReqr/adopted/device/list/get')
        .data(data)
        .done(callback)
        .go();
};
exports.getAdoptedDevicesByGoodsCatId = function (data, callback) {
    api.post('/devcReqr/adopted/device/list/of/app/get')
        .data(data)
        .done(callback)
        .go();
};

exports.getAdoptedDeviceDevcDefPagedList = function (data, callback) {
    api.post('/devcReqr/adopted/device/devcDef/paged/list/get')
        .data(data)
        .done(callback)
        .go();
};
//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcReqr.js
// module id = 47
// module chunks = 0